import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, withKeys as _withKeys, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "login-wrapper"
};
const _hoisted_2 = { class: "animate login-form clearfix" };
const _hoisted_3 = { class: "form-container clearfix" };
const _hoisted_4 = /*#__PURE__*/ _createStaticVNode("<div class=\"form-header dark clearfix\"><div class=\"float-start\"><i class=\"fa-stack fa-lg fa-2x white-text\"><i class=\"fa fa-circle fa-stack-2x\"></i> <i class=\"fa fa-unlock-alt fa-stack-1x fa-inverse dark-blue-text\"></i></i> <h1 class=\"content-title\">\r\n\t\t\t\t\t\t\t\tTwo Factor Authentication\r\n\t\t\t\t\t\t\t</h1></div></div>", 1);
const _hoisted_5 = { class: "form-body clearfix bg-white" };
const _hoisted_6 = {
    key: 0,
    class: "col-xs-12 col-sm-12 top10 w-100"
};
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("label", { class: "normal" }, "\r\n\t\t\t\t\t\t\t\t\t\tYour Company requires Two Factor Authentication.\r\n\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("label", { class: "normal" }, [
    /*#__PURE__*/ _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\tFor "),
    /*#__PURE__*/ _createElementVNode("strong", null, "Any"),
    /*#__PURE__*/ _createTextVNode(" option to appear your Company needs to have it enabled."),
    /*#__PURE__*/ _createElementVNode("br"),
    /*#__PURE__*/ _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\tFor "),
    /*#__PURE__*/ _createElementVNode("strong", null, "Email"),
    /*#__PURE__*/ _createTextVNode(" option Assure needs SMTP server and your User to have a valid email.\r\n\t\t\t\t\t\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("label", { class: "normal" }, "\r\n\t\t\t\t\t\t\t\t\t\tSelect the Two-Step Verification method you prefer to use:\r\n\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_10 = { class: "col-xs-12 top10 float-start" };
const _hoisted_11 = { class: "col-xs-12 top10 float-end" };
const _hoisted_12 = { key: 0 };
const _hoisted_13 = { class: "col-xs-12 col-sm-12 top10 w-100 text-center" };
const _hoisted_14 = ["src"];
const _hoisted_15 = { class: "col-xs-12 col-sm-12 top10 w-100 text-center" };
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("label", { class: "normal bottom10" }, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tScan this QR Code with a Authenticator App\r\n\t\t\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_17 = { class: "normal" };
const _hoisted_18 = {
    key: 1,
    class: "col-xs-12 top10"
};
const _hoisted_19 = { class: "normal" };
const _hoisted_20 = { class: "col-xs-12 col-sm-12 top20 w-100" };
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("label", { class: "normal" }, "\r\n\t\t\t\t\t\t\t\t\t\tCode\r\n\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_22 = { class: "col-xs-12 top10 float-start" };
const _hoisted_23 = { key: 0 };
const _hoisted_24 = { key: 0 };
const _hoisted_25 = { style: { "color": "red" } };
const _hoisted_26 = { key: 1 };
const _hoisted_27 = /*#__PURE__*/ _createElementVNode("span", { style: { "color": "red" } }, "Session Expired", -1 /* HOISTED */);
const _hoisted_28 = [
    _hoisted_27
];
const _hoisted_29 = { class: "col-xs-12 top10 float-end" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _a;
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_router_link = _resolveComponent("router-link");
    const _component_b_button = _resolveComponent("b-button");
    const _component_b_form_input = _resolveComponent("b-form-input");
    return (_openBlock(), _createElementBlock("form", {
        onKeydown: _cache[2] || (_cache[2] = _withKeys(($event) => ($event.preventDefault()), ["enter"]))
    }, [
        (!((_a = _ctx.loginState) === null || _a === void 0 ? void 0 : _a.isLoggedIn))
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _hoisted_4,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_5, [
                            (!_ctx.loading)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (_ctx.data.method == 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                            _hoisted_7,
                                            _createTextVNode(),
                                            _hoisted_8,
                                            _createTextVNode(),
                                            _hoisted_9,
                                            _createTextVNode(),
                                            _createVNode(_component_multiselect, {
                                                name: "authMethod",
                                                modelValue: _ctx.authMethod,
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.authMethod) = $event)),
                                                "track-by": "value",
                                                label: "text",
                                                placeholder: "Select one option",
                                                options: _ctx.authMethods,
                                                showLabels: false,
                                                allowEmpty: false
                                            }, null, 8 /* PROPS */, ["modelValue", "options"]),
                                            _createTextVNode(),
                                            _createElementVNode("div", _hoisted_10, [
                                                _createVNode(_component_router_link, {
                                                    to: { name: 'login' },
                                                    class: "blue"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tReturn to the Login page\r\n\t\t\t\t\t\t\t\t\t\t")
                                                    ]),
                                                    _: 1 /* STABLE */
                                                })
                                            ]),
                                            _createTextVNode(),
                                            _createElementVNode("div", _hoisted_11, [
                                                _createVNode(_component_b_button, {
                                                    type: "button",
                                                    variant: "primary",
                                                    onClick: _ctx.assignAuthMethod
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tNext\r\n\t\t\t\t\t\t\t\t\t\t")
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["onClick"])
                                            ])
                                        ]))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _createCommentVNode(" App Authentication Method "),
                                            _createTextVNode(),
                                            (_ctx.data.method == 2)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    (_ctx.data.barcodeImageBase64)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                                            _createElementVNode("div", _hoisted_13, [
                                                                _createElementVNode("img", {
                                                                    src: _ctx.data.barcodeImageBase64,
                                                                    width: "300",
                                                                    height: "300"
                                                                }, null, 8 /* PROPS */, _hoisted_14)
                                                            ]),
                                                            _createTextVNode(),
                                                            _createElementVNode("div", _hoisted_15, [
                                                                _hoisted_16,
                                                                _createTextVNode(),
                                                                _createElementVNode("label", _hoisted_17, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tManual Setup Code : " + _toDisplayString(_ctx.data.secret), 1 /* TEXT */)
                                                            ])
                                                        ]))
                                                        : _createCommentVNode("v-if", true)
                                                ], 64 /* STABLE_FRAGMENT */))
                                                : _createCommentVNode("v-if", true),
                                            _createTextVNode(),
                                            _createCommentVNode(" Email Authentication Method "),
                                            _createTextVNode(),
                                            (_ctx.data.method == 1)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                                    _createElementVNode("div", null, [
                                                        _createElementVNode("label", _hoisted_19, "Verify email to " + _toDisplayString(_ctx.data.userEmail), 1 /* TEXT */)
                                                    ]),
                                                    _createTextVNode(),
                                                    _createElementVNode("div", null, [
                                                        _createVNode(_component_b_button, {
                                                            type: "button",
                                                            variant: "primary",
                                                            onClick: _ctx.sendEmailCode,
                                                            enabled: !_ctx.sending
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\t\tSend code\r\n\t\t\t\t\t\t\t\t\t\t\t")
                                                            ]),
                                                            _: 1 /* STABLE */
                                                        }, 8 /* PROPS */, ["onClick", "enabled"])
                                                    ])
                                                ]))
                                                : _createCommentVNode("v-if", true),
                                            _createTextVNode(),
                                            _createElementVNode("div", _hoisted_20, [
                                                _hoisted_21,
                                                _createTextVNode(),
                                                _createVNode(_component_b_form_input, {
                                                    modelValue: _ctx.code,
                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.code) = $event)),
                                                    modelModifiers: { trim: true },
                                                    type: "text",
                                                    placeholder: _ctx.getCodePlaceholder,
                                                    onKeyup: _withKeys(_ctx.verify, ["enter"]),
                                                    autocomplete: "off",
                                                    name: "CodeDigit",
                                                    autofocus: "",
                                                    required: ""
                                                }, null, 8 /* PROPS */, ["modelValue", "placeholder", "onKeyup"])
                                            ]),
                                            _createTextVNode(),
                                            _createElementVNode("div", _hoisted_22, [
                                                (_ctx.showCountdown)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                                        (_ctx.timeRemainingTokenExpire > 0)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                                                _createElementVNode("span", _hoisted_25, "This session expires in " + _toDisplayString(_ctx.timeRemainingTokenExpire) + " seconds", 1 /* TEXT */)
                                                            ]))
                                                            : (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_28))
                                                    ]))
                                                    : _createCommentVNode("v-if", true),
                                                _createTextVNode(),
                                                _createVNode(_component_router_link, {
                                                    to: { name: 'login' },
                                                    class: "blue"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\tReturn to the Login page\r\n\t\t\t\t\t\t\t\t\t")
                                                    ]),
                                                    _: 1 /* STABLE */
                                                })
                                            ]),
                                            _createTextVNode(),
                                            _createElementVNode("div", _hoisted_29, [
                                                _createVNode(_component_b_button, {
                                                    type: "button",
                                                    variant: "primary",
                                                    onClick: _ctx.verify,
                                                    disabled: _ctx.timeRemainingTokenExpire == 0
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\tVerify\r\n\t\t\t\t\t\t\t\t\t")
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["onClick", "disabled"])
                                            ])
                                        ], 64 /* STABLE_FRAGMENT */))
                                ], 64 /* STABLE_FRAGMENT */))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode("\r\n\t\t\t\t\t\t\tLoading...\r\n\t\t\t\t\t\t")
                                ], 64 /* STABLE_FRAGMENT */))
                        ])
                    ])
                ])
            ]))
            : _createCommentVNode("v-if", true)
    ], 32 /* NEED_HYDRATION */));
}
